import { useMemo } from 'react';
import { Button, Checkbox } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { StepPage } from "../../components/StepPage";
import { PdfViewer } from "../../../components/PdfViewer/PdfViewer";
import { RichTextViewerWithFetch } from "../../../components/RichTextViewerWithFetch/RichTextViewerWithFetch";
import { useStoreActions } from "../../../contexts";
import { useLegalTerms } from "../../../hooks/reactQuery/queries/useLegalTerms";
import styles from "./TermsOfServiceStep.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const {
  TermsOfServiceStepTestIds
} = getTestIds();
export function TermsOfServiceStep(_ref) {
  var _termsOfService$richT;
  let {
    relationship,
    termsOfService,
    onBack,
    onNext,
    isStatementAccepted,
    onStatementChange
  } = _ref;
  const {
    api
  } = useStoreActions();
  const {
    type
  } = termsOfService;
  const {
    legalTerms
  } = useLegalTerms();
  const termsOfServiceName = useMemo(() => {
    return termsOfService.displayName.replace(/\.pdf$/i, '');
  }, [termsOfService.displayName]);
  const statement = useMemo(() => {
    return termsOfService.termsOfService.type === 'explicitApproval' ? termsOfService.termsOfService.explicitApproval.statement : null;
  }, [termsOfService.termsOfService]);
  return /*#__PURE__*/_jsx(StepPage, {
    header: "Review ".concat(termsOfServiceName),
    primaryBtn: /*#__PURE__*/_jsx(Button, {
      disabled: !isStatementAccepted,
      onClick: onNext,
      "data-testid": TermsOfServiceStepTestIds.PrimaryNextButton(),
      children: "Next"
    }),
    onBackBtnClick: onBack,
    contentClassName: styles.content,
    dataTestId: TermsOfServiceStepTestIds.Root(),
    withinFooter: statement ? /*#__PURE__*/_jsx(Checkbox, {
      className: styles.statementCheckbox,
      onChange: e => onStatementChange(e.target.checked),
      "data-testid": TermsOfServiceStepTestIds.StatementCheckbox(),
      checked: isStatementAccepted,
      children: statement
    }) : null,
    children: /*#__PURE__*/_jsx("div", {
      "data-testid": TermsOfServiceStepTestIds.Content(),
      children: type === 'pdf' ? /*#__PURE__*/_jsx(PdfViewer, {
        hideSinglePageLoader: true,
        getFileUrl: async () => await api.business.getLegalTermsDownloadURL(termsOfService.pdf.pdfName, relationship.vendor.id),
        pdfUniqueName: termsOfService.pdf.pdfName
      }) : /*#__PURE__*/_jsx(RichTextViewerWithFetch, {
        queryKey: (_termsOfService$richT = termsOfService.richText.textId) !== null && _termsOfService$richT !== void 0 ? _termsOfService$richT : undefined,
        fetchText: async () => {
          var _legalTerms$find$rich, _legalTerms$find;
          if (termsOfService.richText.textId) {
            const {
              value
            } = await api.texts.getLegalTermsRichTextContent(relationship.id, termsOfService.richText.textId);
            return value;
          }
          return (_legalTerms$find$rich = (_legalTerms$find = legalTerms.find(lt => lt.id === termsOfService.legalTermsId)) === null || _legalTerms$find === void 0 ? void 0 : _legalTerms$find.richTextContent) !== null && _legalTerms$find$rich !== void 0 ? _legalTerms$find$rich : [];
        }
      })
    })
  });
}